export const driverMapPl = {
  title: 'Mapa kierowców',
  subtitle: 'Ostatnia pozycja i pełna historia odebranych lokalizacji.',
  refresh: 'Odśwież',
  search: 'Szukaj kierowcy',
  filter: 'Widoczność',
  all: 'Wszyscy',
  fleet: 'Auta z naszej floty',
  fleetCar: 'Flota · {plate}',
  fresh: 'Aktualna pozycja',
  stale: 'Nieaktualna pozycja',
  waiting: 'Oczekiwanie na pozycję',
  disabled: 'Udostępnianie wyłączone',
  counts: 'Aktualne pozycje: {fresh} / kierowcy: {total}',
  noPosition: 'Brak odebranej pozycji',
  notOnMap:
    'Tego kierowcy nie ma na mapie — nie przesłał jeszcze pozycji albo ma wyłączone udostępnianie.',
  empty: 'Brak kierowców pasujących do filtrów.',
  legend:
    'Czerwony: auto z naszej floty (starszy odczyt jasnoczerwony). Zielony: odczyt do 2 minut. Szary: starszy odczyt. Brak pozycji nie oznacza nieobecności.',
  accuracy: 'Dokładność: około {metres} m',
  live: 'Bieżąca mapa',
  day: 'Dzień (czas polski)',
  history: 'Pokaż historię',
  points: 'Zapisane punkty: {count}',
  gaps: 'Przerwy ponad 5 minut i nowe sesje rozdzielają trasę.',
  play: 'Odtwórz',
  pause: 'Pauza',
  time: 'Punkt w czasie',
  noHistory: 'Brak zapisanych pozycji w wybranym dniu.',
  historyNote:
    'Historia obejmuje pozycje odebrane od włączenia funkcji. Brak sieci lub sygnału może tworzyć luki.',
  loadError:
    'Nie udało się odświeżyć mapy. Sprawdź połączenie i czas ostatniego odczytu.',
  historyError: 'Nie udało się pobrać całej historii. Spróbuj ponownie.',
  layers: 'Warstwy mapy',
  layerApp: 'Nasza apka',
  layerBolt: 'Bolt',
  boltOnly: 'Aktywni w Bolcie, apka BTP nie wysyła',
  boltNoApp: 'Aktywny w Bolcie, apka BTP nie wysyła',
  boltLine: 'Bolt: {state} · {time}',
  boltNoCoords: 'Bolt: {state} · {time} (pozycja ukryta — kierowca nie włączył lokalizacji w apce)',
  boltState: {
    waiting_orders: 'czeka na kurs',
    waiting: 'czeka na kurs',
    has_order: 'ma zlecenie',
    on_ride: 'w kursie',
    busy: 'zajęty',
    on_break: 'przerwa',
    inactive: 'nieaktywny',
  },
  source: {
    both: 'Pozycja z Bolta i z apki',
    bolt: 'Pozycja z Bolta',
    app: 'Pozycja z apki',
  },
  agoMin: '{n} min temu',
  agoH: '{n} godz. temu',
  agoD: '{n} dni temu',
  boltPoints: 'Punkty z Bolta: {count}',
  boltLegend:
    'Jedna kropka na kierowcę w najświeższej znanej pozycji. Litera B: pozycja z Bolta (sama albo zgodna z apką). Podpis mówi, skąd jest pozycja i ile ma minut.',
};
export const driverMapEn = {
  title: 'Driver map',
  subtitle: 'Last known position and full history of received locations.',
  refresh: 'Refresh',
  search: 'Find a driver',
  filter: 'Visibility',
  all: 'All drivers',
  fleet: 'Our fleet cars',
  fleetCar: 'Fleet · {plate}',
  fresh: 'Current position',
  stale: 'Outdated position',
  waiting: 'Waiting for position',
  disabled: 'Sharing disabled',
  counts: 'Current positions: {fresh} / drivers: {total}',
  noPosition: 'No position received',
  notOnMap:
    'This driver is not on the map — no position received yet or sharing is disabled.',
  empty: 'No drivers match these filters.',
  legend:
    'Red: our fleet car (light red when older). Green: received within 2 minutes. Grey: older position. Missing location does not mean absence.',
  accuracy: 'Accuracy: approximately {metres} m',
  live: 'Live map',
  day: 'Day (Polish time)',
  history: 'Show history',
  points: 'Recorded points: {count}',
  gaps: 'Gaps over 5 minutes and new sessions split the route.',
  play: 'Play',
  pause: 'Pause',
  time: 'Point in time',
  noHistory: 'No positions recorded on this day.',
  historyNote:
    'History includes positions received since enabling the feature. Network or signal loss may create gaps.',
  loadError:
    'Could not refresh the map. Check your connection and the last position time.',
  historyError: 'Could not load the complete history. Please retry.',
  layers: 'Map layers',
  layerApp: 'Our app',
  layerBolt: 'Bolt',
  boltOnly: 'Active in Bolt, BTP app not sending',
  boltNoApp: 'Active in Bolt, BTP app not sending',
  boltLine: 'Bolt: {state} · {time}',
  boltNoCoords: 'Bolt: {state} · {time} (position hidden — driver has not enabled location in the app)',
  boltState: {
    waiting_orders: 'waiting for orders',
    waiting: 'waiting for orders',
    has_order: 'has an order',
    on_ride: 'on a ride',
    busy: 'busy',
    on_break: 'on break',
    inactive: 'inactive',
  },
  source: {
    both: 'Position from Bolt and the app',
    bolt: 'Position from Bolt',
    app: 'Position from the app',
  },
  agoMin: '{n} min ago',
  agoH: '{n} h ago',
  agoD: '{n} days ago',
  boltPoints: 'Bolt points: {count}',
  boltLegend:
    'One dot per driver at the latest known position. Letter B: position from Bolt (alone or matching the app). The label shows the source and its age.',
};
